export interface PaymentStatusInterface {
  [key: number]: {
    VALUE: string;
    PROCESSING?: boolean;
    [key: number]: { VALUE: string; CONFIRMED?: boolean };
  };
}

const PAYMENT_TYPE = {
  0: { VALUE: 'Em Processamento', PROCESSING: true },
  1: { VALUE: 'Em Processamento', PROCESSING: true },
  2: {
    VALUE: '',
    0: { VALUE: 'Confirmado', CONFIRMED: true },
    1: { VALUE: 'Expirado' },
    2: { VALUE: 'Já Utilizado' },
    3: { VALUE: 'Cancelado' },
  },
  3: { VALUE: 'Erro' },
  4: { VALUE: 'Cancelado' },
  10: { VALUE: 'Reagendado' },
};

const STATUS_PRIORITY = [
  { KEY: 2, VALUE: 'Já Utilizado' },
  { KEY: 1, VALUE: 'Expirado' },
  { KEY: 10, VALUE: 'Reagendado' },
  { KEY: 0, VALUE: 'Confirmado' },
  { KEY: 3, VALUE: 'Cancelado' },
];

const TICKET_SALES_TYPE_BY_OPERATOR_HOMOLOG = {
  'eecafbaf-d269-4413-a612-4fd984ae9670': 'ship',
  '8dcf2467-772f-4837-aca6-e820acf8a5d3': 'ship',
  '5f75a143-461d-419a-8b48-301f518ee0a8': 'ship',
  '533ef7e0-33a7-44b8-a6e6-134ff8601afd': 'busscheduled',
  'd3842550-870a-435f-841f-0e83f48dcdc6': 'busscheduled',
  '576adf51-4370-4bf8-8757-edc20a18e965': 'busscheduled',
  'ae1353d4-a8f3-47e0-950d-0c5de74d1261': 'busscheduled'
};
const CHANNEL = 'website';
const SINGLE_TIKET = 'FREE';
const BOARDING_TAX_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_VALUE: 'FIXED_VALUE',
};

const OPERATION = {
  REMOVE: 'REMOVE',
  ADD: 'ADD',
};

const SEAT_POSITION = {
  WINDOW_LEFT: 0,
  CORRIDOR_LEFT: 1,
  CORRIDOR_RIGHT: 2,
  WINDOW_RIGHT: 3,
};

// Parâmetros de query do link de detalhes da passagem (QR Code dos pontos)
const TICKET_SALES_QUERY_PARAMS = {
  INITIAL_STOP_ID: 'initialStopId',
  FINAL_STOP_ID: 'finalStopId',
  NEXT_AVAILABLE_DATE: 'nextAvailableDate',
};

export {
  PAYMENT_TYPE,
  STATUS_PRIORITY,
  SINGLE_TIKET,
  BOARDING_TAX_TYPE,
  OPERATION,
  TICKET_SALES_TYPE_BY_OPERATOR_HOMOLOG,
  CHANNEL,
  SEAT_POSITION,
  TICKET_SALES_QUERY_PARAMS,
};
